import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import TeamSecThree from '../components/sections/TeamSecThree';
import CtaSecOne from '../components/sections/CtaSecOne';
import BlogSecOne from '../components/sections/BlogSecOne';

const Team = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.team.title" subtitleKey="sections.breadcrumb.team.subtitle" />
        <TeamSecThree className="space overflow-hidden" />
        <CtaSecOne className="space bg-smoke overflow-hidden" />
        <BlogSecOne className="space overflow-hidden" />
      <Footer />
    </>
  );
};

export default Team;